import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

import { interval as observableInterval, Observable, Subject } from 'rxjs';
import { first, last, takeUntil } from 'rxjs/operators';

import {
  NotificationBodyBase,
  NotificationsContainerComponent,
  NotificationStyle,
} from '@recruitee/user-interface';

import { AsyncJobViewNotificationModel } from '../../async-job-view.types';

@Component({
  selector: 'rt-async-jobs-notification',
  templateUrl: './async-jobs-notification.component.html',
  styleUrls: ['./async-jobs-notification.component.less'],
  host: {
    '(click)': 'notificationClick.emit(job.uuid)',
  },
})
export class AsyncJobsNotificationComponent extends NotificationBodyBase {
  @Input() public title?: string;
  @Input() public message?: string;
  @Input() public actionButtonLabel?: string;
  @Output() public actionButtonClick: EventEmitter<void> = new EventEmitter();
  @Output() public closeNotification: EventEmitter<string> = new EventEmitter();
  @Output() public notificationClick: EventEmitter<string> = new EventEmitter();

  public job: AsyncJobViewNotificationModel = <AsyncJobViewNotificationModel>{};
  public containerComponent: NotificationsContainerComponent;

  public jobDisplayStream$: Observable<AsyncJobViewNotificationModel>;

  public style: string;
  public NotificationStyle: NotificationStyle;

  public ngOnDestroy$ = new Subject<void>();

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public setJobDisplayStream(jobDisplayStream$: Observable<AsyncJobViewNotificationModel>) {
    this.jobDisplayStream$ = jobDisplayStream$;
    this.jobDisplayStream$.pipe(takeUntil(this.ngOnDestroy$.asObservable())).subscribe(job => {
      this.job = job;

      if (job.notificationConfig?.style) {
        this.updateStyle(job.notificationConfig.style);
      }

      this.cdRef.detectChanges();
    });

    this.jobDisplayStream$.pipe(last()).subscribe(job => {
      if (job.errors.length === 0) {
        const timeout =
          job.notificationConfig && job.notificationConfig!.timeout! > 0
            ? job.notificationConfig.timeout
            : 5000;
        this.updateStyle(NotificationStyle.Success);
        observableInterval(timeout)
          .pipe(first())
          .subscribe(() => this.closeNotification.emit(job.uuid));
      } else {
        this.updateStyle(NotificationStyle.Error);
      }
    });
  }

  public detectChanges() {
    this.cdRef.detectChanges();
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public setMessage(message: string): void {
    this.message = message;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setMessageHTML(message: string): void {}

  private updateStyle(style: NotificationStyle): void {
    setTimeout(() => {
      this.style = style;
      this.cdRef.detectChanges();
    });
  }
}
